import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricConversionKayak extends MetricBase {
    constructor() {
        super({
            field: "metric_conversion_rate",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.kayak.conversion.chartName"),
            serieLabel: i18n.t("metrics.kayak.conversion.serieLabel"),
            tooltip: i18n.t("metrics.kayak.conversion.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricConversionKayak;
